import { Avatar, AvatarSize, Spinner, theme } from '@ketch-com/deck'
import { Box, Typography } from '@mui/material'
import { useDataSentryContext } from 'pages/dataSentry/context/DataSentryContext'
import { formatCountCopy } from 'pages/dataSentry/utils/formatCountCopy'
import React from 'react'

export const TopCollectorCard: React.FC = () => {
  const { topSystems, isTopSystemsLoading } = useDataSentryContext()
  const system = topSystems.length ? topSystems[0] : null
  const systemCollectionEventsCopy =
    typeof system?.collectionEvents === 'number'
      ? `${formatCountCopy(system.collectionEvents)} Collection Events`
      : 'Not Enough Data'
  return (
    <Box display="flex" justifyContent="center" width="100%">
      {isTopSystemsLoading ? (
        <Box display="flex" alignItems="center" justifyContent="center" minHeight={150}>
          <Spinner size="32px" thickness={2.5} />
        </Box>
      ) : (
        <Box display="flex" flexDirection="column">
          <Typography variant="smallLabel" color={theme.palette.Text.Secondary} my={1} textAlign="center">
            Top Data Collector
          </Typography>

          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            minHeight={120}
            gap={0.5}
          >
            {system?.logo ? (
              <Avatar
                src={system.logo}
                variant="circular"
                borderColor={theme.palette.Black.o8}
                size={AvatarSize['2xlarge']}
                isLogo
              />
            ) : system?.code ? (
              <Avatar
                icon="NoLogo"
                textColor={theme.palette.Text.Secondary}
                borderColor={theme.palette.Black.o8}
                size={AvatarSize['2xlarge']}
                isLogo
              />
            ) : (
              <Avatar
                icon="FUnknown"
                textColor={theme.palette.Text.Secondary}
                borderColor={theme.palette.Black.o8}
                size={AvatarSize['2xlarge']}
                isLogo
              />
            )}
            <>
              {system?.name ? (
                <Typography variant="label">{system.name}</Typography>
              ) : system?.code ? (
                <>
                  <Typography variant="label">Unknown</Typography>
                  <Typography variant="footnote">{system?.code}</Typography>
                </>
              ) : (
                <>
                  <Typography variant="label" color={theme.palette.Text.Secondary}>
                    No Data
                  </Typography>
                </>
              )}

              {system?.name || system?.code ? (
                <Typography variant="smallBody">{systemCollectionEventsCopy}</Typography>
              ) : null}
            </>
          </Box>
        </Box>
      )}
    </Box>
  )
}
